import { defaultProps } from 'recompose';

import { defaultWidgetConfig } from 'constants';

import CommonButton from './CommonButton';

export default defaultProps({
  tooltipText: 'Notifications',
  widget: defaultWidgetConfig,
})(CommonButton);
